import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="10177" id="project-overview" ref={ref} className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className={`absolute inset-0 z-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-105 blur-sm"}`}>
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/civil_engineering_drone.png)]" />
        {}
        <div className="absolute inset-0 bg-primary/40 mix-blend-multiply" />
      </div>

      {}
      <div className={`relative z-10 container mx-auto px-6 text-center transition-all duration-700 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}>
        <div className="max-w-3xl mx-auto flex flex-col items-center gap-8">
          {}
          <h1 className="font-default font-extrabold text-5xl md:text-7xl lg:text-[5rem] tracking-tight text-accent drop-shadow-md">
            Project 3
          </h1>

          {}
          <p className="font-mono text-lg md:text-xl text-white max-w-xl leading-relaxed">
            TECHNICAL SPECIFICATIONS: High-capacity structural framework utilizing precision-engineered steel and reinforced concrete components for industrial-scale deployment.
          </p>

          {}
          <div className="pt-4">
            <Button asChild className="rounded-none bg-primary text-primary-foreground border-l-4 border-l-ring px-10 py-6 text-base font-bold tracking-wide transition-all duration-300 hover:-translate-y-[2px] hover:shadow-xl hover:bg-primary/90 relative overflow-hidden group">
              <Link to="/ProjectsPage">
                <span className="relative z-10">View Details</span>
                {}
                <span className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent z-0" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}